module.exports = "/static/assets/befec8dfc41e846d9bbe24c87f0a003c.svg";